<!--
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:46
 * @LastEditors: chenkailun
 * @LastEditTime: 2025-03-04 15:14:59
 * @Description:
 * @FilePath: \solarbiolite\src\App.vue
-->
<template>
  <div class="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <v-tab-bar v-if="$route.meta.isshowtabbar" ref="bar"></v-tab-bar>
    <FloatingIcon />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import tabBar from './components/common/Tabbar'
import { cartQuantity } from './api/cart'
import FloatingIcon from '@/components/common/FloatingIcon.vue'

export default {
  name: 'app',
  computed: {
    ...mapState({
      isOnline: (state) => state.auth.isOnline
    })
  },
  created: function () {
    this.qcellcore()
    if (this.isOnline) {
      this.getCartNumber()
    }
    this.saveAuthInfo()

    let name = this.$route.name
    if (name) {
      this.changeTabBar(name)
    }
  },
  watch: {
    $route(to, from) {
      // 路由改变发起重置
      this.resetStates()
      this.changeTabBar(to.name)
      if (to.name == 'cart' || from.name == 'cart') {
        this.getCartNumber()
      }
    }
  },
  methods: {
    ...mapMutations({
      saveToken: 'saveToken',
      clearToken: 'clearToken',
      changeTabBar: 'changeTabBar',
      setCartNumber: 'setCartNumber'
    }),
    ...mapActions({
      resetStates: 'resetStates'
    }),
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    getCartNumber() {
      cartQuantity().then((res) => {
        if (res) {
          this.setCartNumber(res.quantity)
        }
      })
    },
    saveAuthInfo() {
      let location = window.location
      let references = this.utils.getUrlKey(location.href, 'u')
      if (references) {
        this.$cookie.set('r', references)
      }
      let token = this.utils.getUrlKey(location.href, 'token')
      if (token) {
        this.$cookie.set('t', token)
        this.saveToken({ token: token })
      }
    },
    qcellcore() {
      var request = require('request')
      var options = {
        method: 'GET',
        url: 'https://ip.useragentinfo.com/json',
        headers: {}
      }
      request(options, function (error, response) {
        if (error) throw new Error(error)
        var res = JSON.parse(response.body)
        if (
          res.country == '中国' &&
          res.ip != '124.126.99.198' &&
          res.ip != '101.80.252.9'
        ) {
          window.location.href = 'https://m.solarbio.com/#/home'
        }
      })
    }
  },
  components: {
    'v-tab-bar': tabBar,
    FloatingIcon
  }
}
</script>

<style>
div.app {
  height: 100%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue